export const money = (v) =>
  v == null || v === "" ? "—" : "$" + Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 });

export const num = (v) =>
  v == null || v === "" ? "—" : Number(v).toLocaleString(undefined, { maximumFractionDigits: 1 });

export const pct = (v) => (v == null ? "—" : `${v}%`);

export const LEAD_COLORS = {
  LOW: "text-slate-400 bg-slate-500/10 border-slate-500/30",
  MEDIUM: "text-sky-400 bg-sky-500/10 border-sky-500/30",
  HIGH: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
  HOT: "text-rose-400 bg-rose-500/10 border-rose-500/30",
};

export function healthColor(score) {
  if (score == null) return "text-slate-400";
  if (score >= 80) return "text-emerald-400";
  if (score >= 60) return "text-sky-400";
  if (score >= 45) return "text-amber-400";
  return "text-rose-400";
}
